import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import CreateAccountForm from './CreateAccountForm';
import {
    clearEmailError,
    clearConfirmEmailVaidationError,
    createAccountFormCloseLoginModal,
    createAccountFormShowLoginModal,
    createAccountFormClosePasswordModal,
    onBlur,
    onFocus,
    onChange,
    onSubmit,
    trackClickSignInLink,
    trackView,
    CreateAccountTrackingActionCreators,
    trackV2PasswordError,
    trackPasswordModalClose,
} from '../../actions';
import { MAIN_SIGNIN_PATH, passwordField } from '../../constants';
import { createAccountFormSelector } from '../../selectors';
import {
    trackClickGoogleLogin,
    trackClickFacebookLogin,
    trackClickAppleLogin,
} from '@zocdoc-frontend-common/components-sign-in-form/components/SignInFormPatientProviderMode/SignInFormPatientProviderModeActions';
import { signInReset } from '@zocdoc-frontend-common/components-sign-in-form/signInFormActions';
import { wrapWithDispatch } from '@zocdoc-frontend-common/utils-react/wrapWithDispatch';
import shouldShowNewUsersSsoSelector from '../../../../selectors/ShouldShowNewUsersSsoSelector';

export const mapDispatchToProps = (dispatch, ownProps) => ({
    clearEmailError: () => dispatch(clearEmailError()),
    clearConfirmEmailVaidationError: () =>
        dispatch(clearConfirmEmailVaidationError()),
    onClosePasswordModal: () => {
        dispatch(createAccountFormClosePasswordModal());
        dispatch(trackPasswordModalClose());
        dispatch(onChange(passwordField, ''));
    },
    onShowLoginModal: () => dispatch(createAccountFormShowLoginModal()),
    onCloseLoginModal: () => dispatch(createAccountFormCloseLoginModal()),
    onClickFacebookLogin: () => dispatch(trackClickFacebookLogin()),
    onClickGoogleLogin: () => dispatch(trackClickGoogleLogin()),
    onClickAppleLogin: () => dispatch(trackClickAppleLogin()),
    onChange: (field, value) => {
        dispatch(onChange(field, value));
    },
    onValidationError: () => {},
    onFocus: field => {
        dispatch(onFocus(field));
    },
    onBlur: (field, value) => {
        dispatch(onBlur(field, value));
    },
    onView: field => dispatch(trackView(field)),
    onSubmit: mode => {
        dispatch(onSubmit(mode));
    },
    onPasswordError: () => dispatch(trackV2PasswordError()),
    onSigninClick: () => {
        if (ownProps.onSigninClick) {
            ownProps.onSigninClick();
        }

        dispatch(trackClickSignInLink());
        if (ownProps.signinRedirect) {
            dispatch(push(ownProps.signinRedirect));
        } else {
            window.location.assign(MAIN_SIGNIN_PATH);
        }
    },

    resetLoginModal: () => dispatch(signInReset()),
    ...wrapWithDispatch(CreateAccountTrackingActionCreators, dispatch),
});

export const mapStateToProps = (state = {}, ownProps = {}) => {
    if (state.createAccountForm === undefined) {
        throw new Error(
            'Expected the create account state to be available as `state.createAccountForm`. ' +
                "Ensure you have added the `createAccountFormReducer` to your store's reducers via `combineReducers`."
        );
    }

    const shouldShowNewUsersSSO = shouldShowNewUsersSsoSelector(state);

    return {
        ...createAccountFormSelector({
            ...state,
        }),
        shouldShowNewUsersSSO,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccountForm);
